var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.prefixCls},[_c('div',{class:`${_vm.prefixCls}-title`},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{class:`${_vm.prefixCls}-desc`},[_vm._v(" "+_vm._s(_vm.desc)+" ")]),_c('div',{class:`${_vm.prefixCls}-divide`},[_c('div',{class:`${_vm.prefixCls}-divide-box`}),_c('div',{class:`${_vm.prefixCls}-divide-line`})])])
}
var staticRenderFns = []

export { render, staticRenderFns }